/* eslint camelcase: 0 */
import { UserSeed, User } from '@/infrastructure/network/Legacy/schema'
import { EmptyUserPropsFactory, IUserProps } from '@/entities/Legacy/User'

export const toUserProps = (props: User): IUserProps => {
  if (!props) {
    return EmptyUserPropsFactory()
  }

  const { id, uuid, username, last_name, first_name } = props

  return {
    id,
    uuid,
    username,
    lastName: last_name,
    firstName: first_name
  }
}

export const toUserSeed = (props: IUserProps): UserSeed => {
  const { id, username } = props
  return {
    id,
    username
  }
}
